import { SSOCredentials } from '@models/Auth';
import { apiClient } from '../clients/api';
import { AxiosInstance } from 'axios';
import { AuthResponse } from '@models/Auth';

class AuthService {
	private readonly api: AxiosInstance = apiClient;

	authCredentials(username: string, password: string) {
		return this.api.post<AuthResponse>('/auth/credentials/', {
			username: username,
			password: password,
		});
	}

	authSSO(data: SSOCredentials) {
		return this.api.post<AuthResponse>('/auth/sso', data, { withCredentials: true });
	}

	logout() {
		return '';
	}
}

export { AuthService };
